/*
    Endeca control class for the search page endeca instance.

*/

var site = site || {};
site.endeca = site.endeca || {};
site.endeca.instances = site.endeca.instances || {};
site.endeca.instances.search = site.endeca.instances.search || {};

site.endeca.instances.search.control = site.endeca.generic.Class.create( site.endeca.control, {
    initialize: function( args ) {
        this._super( args );
        var isJQAdress = jQuery.address === true;

        if ( isJQAdress ) {
            var that = this;
            jQuery.address.on( 'change', that, function( event ) {
                that.search( { queryString: $H(event.parameters).toQueryString() } );
            });

            // IE has issues with jQuery Address' initialize because of conflicts with iframes included on the page
            // The following will search unless it has already searched.
            window.setTimeout( function() {
                if ( !that.hasSearched ) {
                    that.search( { queryString: $H(event.parameters).getQueryString() } );
                }
            }, 100);
        } else {
            this.search();
        }

    },

    searchCompleted: function() {
        this._super();

	    this.results.products.resultData = this.catalogs.product.resultList;
        this.results.products.summaryResultData = this.meta.searchInfo;
        this.results.products.displayResults();
        this.results.products.show();

        if ( this.results.products.resultData.length ) {
            this.hasResults = true;
        } else {
            this.results.products.hide();
        }

	    this.results.pagination.resultData = this.meta.pagination;
	    this.results.pagination.displayResults();
	    this.results.pagination.show();
                
        if ( !this.wildcardSearch ) { 
        
            this.results.content.contentzones = this.configuration.contentzones;
            this.results.content.resultData = this.meta.supplementalContent;
            this.results.content.displayResults();
            
            if ( !jQuery.isEmptyObject( this.results.content.resultData ) ) {    
                this.meta.processSearchInfo({ totalContentRecords: this.results.content.totalResults });
                //this.results.content.show();
                if ( this.results.content.hasSoloResults ) { this.hasResults = true; }
            } else {
                this.results.content.hide(); 
            }
        }


        this.results.refinements.resultData = this.meta.dimensions.refinements || [];
        this.results.refinements.displayResults();
        this.results.refinements.show();
        

	    if ( this.meta.dimensions.breadcrumbs ) {
            this.results.breadcrumbs.resultData = this.meta.dimensions.breadcrumbs;
            this.results.breadcrumbs.displayResults();
            this.results.breadcrumbs.show();
            this.results.refinements.openAccordion();
        } else {
            this.results.breadcrumbs.hide();
        }

        if ( !this.meta.dimensions.breadcrumbs && !this.meta.dimensions.refinements ) {
        	this.results.refinements.hide();
        }
        
        this.results.summary.resultData = jQuery.extend( this.meta.searchInfo, { breadcrumbs: this.meta.dimensions.breadcrumbs } );
        this.results.summary.hasResults = this.hasResults;
        this.results.summary.displayResult();

	    this.displayResults();
    },

    showLoading: function() {
        if ( this.results.products ) { this.results.products.reset(); }
        if ( this.results.content ) { this.results.content.reset(); }
        this._super();
    }
});
